(function() {
    angular.module('tmx-app').controller('GuarantorGuaranteeDialogController', ['$mdDialog','$scope','guarantorData','lookupService','showAddButton','guarantorTabEditPrivilege','direction', 'ToastService', 

        function GuarantorGuaranteeDialogController($mdDialog,$scope,guarantorData,lookupService,showAddButton,guarantorTabEditPrivilege,direction,ToastService) {
            $scope.vm = {};
            $scope.vm.guarantorData={};
            $scope.vm.guarantorData.TmxGuarantor={};
            $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail={};
            $scope.vm.guarantorData.TmxGuarantor.TmxGuarantorGuaranteeDetail = guarantorData;
            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
            $scope.direction=direction;

            $scope.ok = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide();
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };
            $scope.add = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide($scope.vm.guarantorData);
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };


            $scope.cancel = function() {
                $mdDialog.hide();
            };

            $scope.vm.lookup = {};
            lookupService.getLookupByType('ClientRelations').then(function (response) {
                if(response){
                    $scope.vm.lookup.clientRelationshipLkp = response;
                }
            });
			// lookupService.getLookupByType('BANK_MFI').then(function (response) {
			// 	$scope.vm.lookup.bankMFILkp = response;
			// });
            lookupService.getLookupByType('FinancialInstitutionTypes').then(function (response) {
                $scope.vm.lookup.bankMFILkp = response;
            });

            lookupService.getLookupByType('Banks').then(function (response) {
                $scope.vm.lookup.bankLkp = response;
            });
        }]);
              
})();